////////////////////////////////////////////////////////////////////
// This file contains config for the Trustpilot review invitation    //
////////////////////////////////////////////////////////////////////

// Optional. Public reviews page, e.g. https://fr.trustpilot.com/review/perfumee.fr
// This is the only Trustpilot value the section needs: without it the section
// does not render at all.
export const trustpilotProfileUrl = process.env.REACT_APP_TRUSTPILOT_PROFILE_URL;

// Direct "write a review" page, e.g. https://fr.trustpilot.com/evaluate/perfumee.fr.
// The profile URL only shows the reviews, so a reviewer would have to click
// "Écrire un avis" there before they can type anything; the /evaluate/ page
// opens the review form straight away. Derived from the profile URL by default
// (Trustpilot's own URL convention, and the target their Review Collector widget
// uses); REACT_APP_TRUSTPILOT_EVALUATE_URL overrides it if Trustpilot ever
// changes that shape. Falls back to the profile URL untouched when it does not
// look like a /review/ URL.
export const trustpilotEvaluateUrl =
  process.env.REACT_APP_TRUSTPILOT_EVALUATE_URL ||
  (trustpilotProfileUrl ? trustpilotProfileUrl.replace('/review/', '/evaluate/') : undefined);

// Pages where the Trustpilot section is shown, at the bottom of each. List
// revised by Tara (2026-07-26): homepage, "Comment ça marche ?"
// (/p/comment-ca-marche) and "Anti-contrefaçon" (/p/lutte-contrefacon).
//
// "Acheter un parfum" (SearchPage, /s) was in the 2026-07-23 list and has been
// REMOVED on her instruction — the search results page no longer shows the
// section. SearchPageWithListingType (/s/:listingType) stays out too.
export const trustpilotAllowedRouteNames = ['LandingPage'];
export const trustpilotAllowedCMSPageIds = ['comment-ca-marche', 'lutte-contrefacon'];
